// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:900px){.cart-icon svg{margin-right:10px}}.cart-icon svg path{fill:#101820}@media(min-width:900px){.cart-icon.has-address svg{margin-right:15px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
